// Checks if content contains typography Markdown
export default function isMarkdown(text) {
    return typeof text === 'string' && text.startsWith("@markdown");
}
